import { useSyncExternalStore } from "react";

export type Breakpoint = "mobile" | "tablet" | "desktop";

const TABLET = "(min-width: 768px)";
const DESKTOP = "(min-width: 1024px)";

function subscribe(onChange: () => void) {
  const queries = [TABLET, DESKTOP].map((q) => window.matchMedia(q));
  for (const mql of queries) mql.addEventListener("change", onChange);
  return () => {
    for (const mql of queries) mql.removeEventListener("change", onChange);
  };
}

/** Faixa de largura neste instante (fora do React, ex.: ao abrir um painel). */
export function currentBreakpoint(): Breakpoint {
  if (window.matchMedia(DESKTOP).matches) return "desktop";
  if (window.matchMedia(TABLET).matches) return "tablet";
  return "mobile";
}

/** Faixa de largura atual: celular (< 768), tablet (768–1023) ou desktop (≥ 1024); reage a redimensionamento. */
export function useBreakpoint(): Breakpoint {
  return useSyncExternalStore(subscribe, currentBreakpoint, () => "desktop");
}
